import { createContext, useContext, useState } from 'react'

// Types de formulaires disponibles
export const FORM_TYPES = {
  EDIT: 'edit',             // Formulaire d'édition d'une location existante
  NEW: 'new',               // Formulaire de création d'une nouvelle location
  CLOSE: 'close',           // Formulaire de clôture d'une location
  CLOSE_EDIT: 'close-edit'  // Formulaire d'édition d'une location clôturée
}

// Création du contexte avec des valeurs par défaut
export const LocationFormContext = createContext({
  // Type de formulaire actif
  formType: FORM_TYPES.EDIT,
  setFormType: () => {},
  
  // Fonctions de gestion des erreurs
  getErrorMessage: () => '',
  hasError: () => false,
  
  // Données du formulaire
  control: null,
  location: null,
  isLoading: false,
  
  // Fonctions de callback pour la modale
  onClose: () => {},
  onSuccess: () => {},
})

// Provider du contexte
export const LocationFormProvider = ({ children, initialFormType = FORM_TYPES.EDIT, ...contextValues }) => {
  const [formType, setFormType] = useState(initialFormType)
  
  return (
    <LocationFormContext.Provider
      value={{
        ...contextValues,
        formType,
        setFormType
      }}
    >
      {children}
    </LocationFormContext.Provider>
  )
}

// Hook personnalisé pour utiliser le contexte
export const useLocationForm = () => {
  const context = useContext(LocationFormContext)
  
  if (!context) {
    throw new Error('useLocationForm doit être utilisé à l\'intérieur d\'un LocationFormProvider')
  }
  
  return context
}